import { UserManager } from "oidc-client-ts";
import AuthAdapter from "../adapters/AuthAdapter";
import { OIDC_CONFIG } from "../utility/Keycloak";

let _singleton = true;
let _instance: any;
let _authToken: string;
let _user: any;
let _tokenType: string;
let _userToken: any;

class AuthService {
  userManager = new UserManager(OIDC_CONFIG);
  authAdapter = AuthAdapter.instance;

  constructor() {
    if (_singleton) {
      throw new SyntaxError("This is singleton class");
    }
  }

  static get instance() {
    if (!_instance) {
      _singleton = false;
      _instance = new AuthService();
      _singleton = true;
    }
    return _instance;
  }

  get isAuthorisedUser() {
    // const user = this.authAdapter.user;
    return true;
  }

  get authToken() {
    const authtoken = this.rawAuthToken;
    return `${_tokenType} ${authtoken}`;
  }
  get rawAuthToken() {
    return _authToken;
  }
  set authToken(value: any) {
    _tokenType = value?.token_type || "Bearer";
    _authToken = value?.access_token;
    _user = value?.profile;
    _userToken = value?.id_token;
  }

  get user() {
    return _user;
  }

  async logout(language: any) {
    // this.userManager.clearStaleState();
    try {
      await this.userManager.signoutRedirect({
        id_token_hint: _userToken || "",
        extraQueryParams: {
          action: "asha_login",
          ui_locales: language,
        },
      });
    } catch (error) {
      if (error?.toString().indexOf("Failed to fetch") !== -1) {
        document.dispatchEvent(new CustomEvent("NetworkError"));
      }
    }
  }

  async logoutSilent(language: any) {
    return await this.userManager.signoutSilent({
      extraQueryParams: {
        action: "asha_login",
        ui_locales: language,
      },
    });
  }
  async idleLogout(language: any, sessionExpired: boolean) {
    const tokenTemp = sessionExpired
      ? {
          post_logout_redirect_uri: OIDC_CONFIG.idle_redirect_uri,
          extraQueryParams: {
            action: "asha_login",
            ui_locales: language,
          },
        }
      : {
          post_logout_redirect_uri: OIDC_CONFIG.post_logout_redirect_uri,
          id_token_hint: _userToken,
          extraQueryParams: {
            action: "asha_login",
            ui_locales: language,
          },
        };
    return await this.userManager.signoutRedirect(tokenTemp);
  }
}

export default AuthService;
